<section class="tokenomics" id="tokenomics">
    <div class="container">
        <div class="tokenomics-container d-flex flex-column">
            <div class="title-section">
                <h2 class="section-title mx-auto text-center mb-3 text-white">
                    {{ 'tokenomics.title' | translate }}
                </h2>
                <p class="section-desc mb-0">{{ 'tokenomics.desc' | translate }}</p>
            </div>
            <div class="distribution-cards">
                <div class="distribution d-flex flex-column" *ngFor="let distri of distribution"
                    [ngClass]="distri.theme">
                    <div class="d-flex flex-column justify-content-between align-items-start  h-100 ">
                        <div class="d-flex flex-column flex-grow-1">
                            <div class="img-wrapper">
                                <img src="/assets/images/svg-icons/{{distri.img}}.svg" [alt]="distri.title | translate">
                            </div>
                            <span class="percent">{{distri.percent}}%</span>
                            <span class="font-24 font-xxl-28 mb-3 text-white title">{{distri.title | translate}}</span>
                        </div>
                        <span class="font-14 font-xxl-16 text-uppercase desc">{{distri.desc | translate}}</span>
                    </div>
                </div>
            </div>
            <!-- <div class="amount-distribution">
                <div class="amount d-flex flex-column gap-2" *ngFor="let amount of amounts">
                    <span class="font-14 text-light-grey">{{amount.title | translate}}</span>
                    <span class="font-36 text-grey">{{ !amount.txt ? amount.amount : (amount.txt | translate)
                        }}</span>
                    <span class="font-14 amount-desc">{{(amount.desc) | translate}}</span>
                </div>
            </div> -->
            <div class="index-peg d-flex flex-column align-items-center">
                <span class="font-24 font-md-36 index-peg-title mb-3">{{"tokenomics.index_peg_title" |
                    translate}}</span>
                <span class="font-18 font-md-24 subtitle mb-5">{{"tokenomics.index_peg_subtitle" | translate}}</span>
                <span class="col-12 col-md-6 font-16 desc" [innerHTML]="'tokenomics.index_peg_desc' | translate"></span>
                <div class="features">
                    <div class="feature">
                        <span class="text-center">{{"tokenomics.feature1" | translate}}</span>
                    </div>
                    <div class="feature">
                        <span class="text-center">{{"tokenomics.feature2" | translate}}</span>
                    </div>
                    <div class="feature">
                        <span class="text-center">{{"tokenomics.feature3" | translate}}</span>
                    </div>
                    <div class="feature">
                        <span class="text-center">{{"tokenomics.feature4" | translate}}</span>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>